import Highcharts from 'highcharts';
import highchartsMore from 'highcharts/highcharts-more';
import HighchartsReact from 'highcharts-react-official';

// columnrange (the percentile band series) lives in highcharts-more.
highchartsMore(Highcharts);

export const ChartSection = ({
  options,
}: {
  options: Record<string, unknown>;
}) => <HighchartsReact highcharts={Highcharts} options={options} />;
